import { render } from "./ProjectExpenses.vue?vue&type=template&id=dbb90836&scoped=true"
import script from "./ProjectExpenses.vue?vue&type=script&lang=js"
export * from "./ProjectExpenses.vue?vue&type=script&lang=js"

import "./ProjectExpenses.vue?vue&type=style&index=0&id=dbb90836&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb90836"]])

export default __exports__